import {
  http,
  setXAuthHeader,
  removeXAuthHeader,
  attachTimeoutHook,
  detachTimeoutHook,
  detachTooManyRequestsHook
} from "@/services/http";

import jwt_decode from "jwt-decode";

const token = JSON.parse(localStorage.getItem("token"));
const refreshToken = JSON.parse(localStorage.getItem("refreshToken"));
const userExplicitlyProceedsWithoutLogin = JSON.parse(localStorage.getItem("userExplicitlyProceedsWithoutLogin")) || false;

export const auth = {
  namespaced: true,
  state: {
    token,
    refreshToken,
    userExplicitlyProceedsWithoutLogin,
    tooManyRequestsHookAttached: false
  },
  getters: {
    userLoggedIn(state) {
      const localStorageTokenIsSet = JSON.parse(localStorage.getItem("token")) !== null;
      const tokenIsSet = state.token !== null;
      return localStorageTokenIsSet || tokenIsSet;
    },
    userMayProceed(state, getters) {
      if(getters.userLoggedIn || state.userExplicitlyProceedsWithoutLogin) {
        return true;
      } else {
        return false;
      }
    },
    decodedToken(state, getters) {
      if(state.token) {
        return jwt_decode(state.token);
      } else {
        return null;
      }
    }
  },
  mutations: {
    token(state, value) { state.token = value },
    refreshToken(state, value) { state.refreshToken = value },
    userExplicitlyProceedsWithoutLogin(state, value) { state.userExplicitlyProceedsWithoutLogin = value },
    tooManyRequestsHookAttached(state, value) { state.tooManyRequestsHookAttached = value },
  },
  actions: {
    setXAuthHeader({ state, getters }) {
      return new Promise(resolve => {
        setXAuthHeader(state.token);
        attachTimeoutHook();
        resolve();
      });
    },
    removeXAuthHeader({state}) {
      return new Promise(resolve => {
        removeXAuthHeader();
        detachTimeoutHook();
        resolve();
      });
    },
    setToken({ commit }, value) {
      return new Promise(resolve => {
        localStorage.setItem("token", JSON.stringify(value));
        commit("token", value);
        resolve();
      });
    },
    setRefreshToken({ commit }, value) {
      return new Promise(resolve => {
        localStorage.setItem("refreshToken", JSON.stringify(value));
        commit("refreshToken", value);
        resolve();
      });
    },
    setUserExplicitlyProceedsWithoutLogin({ commit }, value) {
      return new Promise(resolve => {
        localStorage.setItem("userExplicitlyProceedsWithoutLogin", JSON.stringify(value));
        commit("userExplicitlyProceedsWithoutLogin", value);
        resolve();
      });
    },
    login({ dispatch, commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        http
          .post("/auth/login/", { email, password })
          .then(response => {
              console.log('response: ', response);
            return Promise.all([
              dispatch("setToken", response.data.access),
              dispatch("setRefreshToken", response.data.refresh),
              dispatch("setUserExplicitlyProceedsWithoutLogin", false)
            ]);
          })
          .then(() => { return dispatch("setXAuthHeader") })
          .then(resolve)
          .catch(err => {
            reject(err);
          });
      });
    },
    logout({ dispatch, commit }) {
      return new Promise(resolve => {
        detachTooManyRequestsHook();
        dispatch("removeXAuthHeader")
        .then(()=> {
          return Promise.all([
            dispatch("setToken", null),
            dispatch("setRefreshToken", null),
            dispatch("setUserExplicitlyProceedsWithoutLogin", false)
          ]);
        })
        .then(resolve);
      });
    },
    register({ dispatch, commit }, data) { //WIP
      return new Promise((resolve, reject) => {
        http
          .post('/auth/registration/', data)
          .then(response => {
            resolve(response.data);
          }).catch((error_) =>{
            reject(error_.response.data);
          });
      });
    },
    requestNewPassword({ dispatch, commit}, data) {
      return new Promise((resolve, reject) => {
        http
          .post('/auth/reset-password/', data)
          .then((response) => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
      })
    },
    changePassword({ dispatch, commit }, data) { //WIP
      return new Promise((resolve, reject) => {
        http
          .post("/auth/reset-password/confirm/", data)
          .then(response => {
            console.log('response: ', response);
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    verifyEmail({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {
          http
            .post('/auth/registration/verify-email/', data)
            .then((response) => {
              console.log('response: ', response);
              resolve(response);
            })
            .catch((err) => {
              reject(err);
            })
      });
    },
    contactUs({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {

      })
    }
  }
};
